import { Button } from '@/shared/ui/Button';
import { Input } from '@/shared/ui/Input/Input';
import { Typography } from '@/shared/ui/Typography/Typography';
import * as React from 'react';
import { Link } from 'react-router-dom';
import LinkArrowIcon from '@/assets/icons/linkArrow.svg?react';
import { FeedbackSuccessCard } from '@/features/feedback/ui/FeedbackSuccessCard';
import { handleSendReq } from '@/shared/lib/utils/contact';

export interface ITakeContactsProps {}

type userInfoType = {
  name: {
    value: string;
    error: string;
  };
  phone: {
    value: string;
    error: string;
  };
  term: boolean;
};

export function TakeContacts(props: ITakeContactsProps) {
  const [userInfo, setUserInfo] = React.useState<userInfoType>({
    name: { value: '', error: '' },
    phone: { value: '', error: '' },
    term: false,
  });

  const [success, setSuccess] = React.useState<boolean>(false);

  const validate = () => {
    let isValid = true;
    const newUserInfo = { ...userInfo };

    if (!userInfo.name.value.trim()) {
      newUserInfo.name.error = 'Введите имя';
      isValid = false;
    } else {
      newUserInfo.name.error = '';
    }

    const phoneRegex = /^\+?[0-9\s-]{10,15}$/;
    if (!userInfo.phone.value.trim()) {
      newUserInfo.phone.error = 'Введите номер телефона';
      isValid = false;
    } else if (!phoneRegex.test(userInfo.phone.value)) {
      newUserInfo.phone.error = 'Неверный формат номера';
      isValid = false;
    } else {
      newUserInfo.phone.error = '';
    }

    setUserInfo(newUserInfo);
    return isValid;
  };

  const handleInputChange = (field: 'name' | 'phone', value: string) => {
    setUserInfo((prev) => ({
      ...prev,
      [field]: {
        ...prev[field],
        value,
        error: '',
      },
    }));
  };

  const handleCheckboxChange = (value: boolean) => {
    setUserInfo((prev) => ({ ...prev, term: value }));
  };

  const hadleCloseSuccess = () => {
    setUserInfo({
      name: { value: '', error: '' },
      phone: { value: '', error: '' },
      term: false,
    });
    setSuccess(false);
  };

  const handleSubmit = async () => {
    if (!userInfo.term) {
      alert('Пожалуйста, подтвердите согласие на обработку данных.');
      return;
    }

    if (!validate()) {
      return;
    }

    const result = await handleSendReq(
      userInfo.name.value,
      userInfo.phone.value,
      userInfo.term,
      window.location.href
    );
    if (result && result.firstname) {
      setSuccess(true);
    }
  };

  return (
    <div className="shadow-cls relative flex flex-col gap-[20px] rounded-[20px] p-[24px] md:flex-row xl:p-[40px]">
      <div className="flex flex-col justify-between gap-[12px] md:w-1/2">
        <Typography className="text-[24px] font-[600] xl:text-[26px]">
          ОСТАВЬТЕ СВОИ КОНТАКТЫ И МЫ ПЕРЕЗВОНИМ
        </Typography>
        <Typography className="text-[16px] font-[400]">
          Специалист свяжется с вами в ближайшее время
        </Typography>
      </div>

      <div className="flex flex-col gap-[12px] md:w-1/2">
        <Input
          className="h-[43px] rounded-full border border-black bg-white px-[24px]"
          placeholder="Имя"
          type="text"
          value={userInfo.name.value}
          error={userInfo.name.error}
          onChange={(e) => handleInputChange('name', e.target.value)}
          required
        />

        <Input
          className="h-[43px] rounded-full border border-black bg-white px-[24px]"
          name="phone"
          type="tel"
          value={userInfo.phone.value}
          error={userInfo.phone.error}
          placeholder="Телефон"
          pattern="^\\+?[0-9\\s-]{10,15}$"
          onChange={(e) => handleInputChange('phone', e.target.value)}
          required
        />

        <div className="flex flex-row items-start gap-2">
          <input
            id="agreeTerms"
            name="agreeTerms"
            type="checkbox"
            checked={userInfo.term}
            className="mt-1 text-[var(--black-grey)] accent-[var(--black-grey)] focus:ring-0"
            onChange={(e) => handleCheckboxChange(e.target.checked)}
            required
          />
          <label htmlFor={'agreeTerms'}>
            <Typography className="text-[10px] text-[var(--black-grey)]">
              Я полностью ознакомился и согласен с
              <Link to="/privacy-policy" className="text-[#116ACC]">
                {' '}
                Пользовательским соглашением, Политикой обработки персональных
                данных и файлов Cookie.
              </Link>
              , и предоставляю конкретное, предметное, информированное,
              сознательное и однозначное Согласие на обработку моих персональных
              данных.
            </Typography>
          </label>
        </div>

        <Button
          endIcon={<LinkArrowIcon className="h-[30px] w-[30px]" />}
          text="Заказать звонок"
          bg="black"
          className="h-[38px] w-full p-[4px] pl-[16px] text-[16px] font-[400] md:h-[42px] md:pr-[6px]"
          type="submit"
          onClick={() => handleSubmit()}
        />
      </div>
      {success && <FeedbackSuccessCard handleClose={hadleCloseSuccess} />}
    </div>
  );
}
